import type { World } from '../engine/World';
import type { WorldState } from '../engine/WorldState';
import type { WorldEvent } from '../types';
import { EFFECT_META } from '../effects/registry';
import { sfx } from '../engine/Sfx';
import { showClaim, showCodex, showLedger } from './modal';

const ICON: Record<string, string> = {
  轻: '⚡', 中: '✨', 大: '🌟', 戏剧: '🌗', 安全: '☁',
};

/**
 * HUD:顶栏(纪元/香火条/在线)+ 神谕流。绑定 WorldState,权威渲染。
 */
export function mountHud(world: World, state: WorldState) {
  const epochLabel = document.getElementById('epoch-label')!;
  const faithNum = document.getElementById('faith-num')!;
  const faithFill = document.getElementById('faith-fill')!;
  const faithNext = document.getElementById('faith-next')!;
  const onlineNum = document.getElementById('online-num')!;

  const fmt = (n: number) => n.toLocaleString('en-US');

  const render = (s: WorldState) => {
    epochLabel.textContent = `第${s.epochOrdinal}纪元 · ${s.epochName}`;
    faithNum.textContent = fmt(s.faith);
    faithFill.style.width = `${(s.faithProgress() * 100).toFixed(1)}%`;
    // 冲刺预热:≥85% 进度条发光,与火种躁动同步制造"就差一点"的集体感
    faithFill.classList.toggle('hot', s.faithProgress() >= 0.85 && !!s.next());
    const nx = s.next();
    faithNext.textContent = nx ? `/ 下一里程碑 ${fmt(nx.faith)}(${nx.name})` : '· 已至飞升纪';
    onlineNum.textContent = fmt(s.onlineGods);
  };
  state.on(render);
  render(state);

  // ── 神谕流 ──
  const track = document.getElementById('os-track')!;
  const lines: string[] = [
    '灵墟受理神谕中……', '发弹幕=许愿', '写诗=刻碑', '投币=香火',
  ];
  const rebuild = () => {
    track.innerHTML = lines
      .map((t) => `<span class="os-item">${t}</span>`)
      .join('<span class="os-item" style="opacity:.4">·</span>');
  };
  rebuild();

  world.onEventPlayed = (ev: WorldEvent) => {
    const meta = EFFECT_META[ev.type];
    const who = ev.source.mid_hash ? `神明 ${ev.source.mid_hash.slice(0, 6)}` : ev.source.uname ? `神明 ${ev.source.uname}` : '灵墟';
    const ic = ICON[meta?.tier ?? '轻'] ?? '⚡';
    lines.unshift(`<span class="ic">${ic}</span><span class="g">${who}</span> · ${meta?.label ?? ev.type}`);
    if (lines.length > 16) lines.pop();
    rebuild();
  };

  // 三大入口 → 游戏内浮层(替换 prompt/alert:系统弹窗对世界观是审美断裂)
  document.getElementById('btn-claim')!.onclick = () => showClaim(world);
  document.getElementById('btn-ledger')!.onclick = () => showLedger(state);
  document.getElementById('btn-codex')!.onclick = () => showCodex(world);

  // 声音开关(顶栏右侧;autoplay 政策下首次点击任意处已解锁 AudioContext)
  const sndBtn = document.createElement('button');
  sndBtn.id = 'btn-sound';
  sndBtn.title = '声音开关';
  const syncSnd = () => { sndBtn.textContent = sfx.enabled ? '🔊' : '🔇'; sndBtn.classList.toggle('off', !sfx.enabled); };
  sndBtn.onclick = () => { sfx.setEnabled(!sfx.enabled); syncSnd(); };
  syncSnd();
  document.querySelector('.tb-right')!.appendChild(sndBtn);
}
